/* eslint-disable prettier/prettier */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login-layout',
        component: () => import(/* webpackChunkName: "layout" */ '@/views/LoginLayout.vue'),
        children: [
            {
                path: '/',
                alias: '/',
                name: 'login',
                meta: { authNotRequired: true },
                component: () => import(/* webpackChunkName: "about" */ '@/views/login/Login.vue'),
            },
        ],
    },
    {
        path: '/logout',
        name: 'logout',
        beforeEnter: (to, from, next) => {
            store.dispatch('logout').then(() => next({ name: 'login' }))
        },
    },
    {
        path: '/',
        name: 'layout',
        component: () => import(/* webpackChunkName: "layout" */ '@/views/Layout.vue'),
        children: [
            {
                path: 'venues',
                alias: '/',
                name: 'venues',
                component: () => import(/* webpackChunkName: "venueoverview" */ '@/views/venues/VenueOverview.vue'),
            },
            {
                path: 'venues/:id',
                name: 'venue',
                redirect: { name: 'venue_overview' },
                component: () => import(/* webpackChunkName: "venue" */ '@/views/venues/Venue.vue'),
                children: [
                    {
                        path: '/',
                        name: 'venue_overview',
                        component: () =>
                            import(/* webpackChunkName: "venueoverview" */ '@/views/venues/VenueEvents.vue'),
                    },
                    {
                        path: 'statistics',
                        name: 'venue_statistics',
                        component: () =>
                            import(/* webpackChunkName: "venueoverview" */ '@/views/venues/VenueStatistic.vue'),
                    },
                    {
                        path: 'historical',
                        name: 'venue_historical_data',
                        component: () =>
                            import(/* webpackChunkName: "venueoverview" */ '@/views/venues/VenueHistoricalData.vue'),
                    },
                ],
            },
            {
                path: '/events',
                name: 'event-overview',
                component: () => import(/* webpackChunkName: "eventoverview" */ '@/views/events/EventOverview.vue'),
            },
            {
                path: '/event/:id/guests',
                name: 'event-guest-list',
                component: () => import('@/views/events/EventGuestList.vue'),
            },
            {
                path: 'events/new',
                name: 'event-new',
                component: () => import(/* webpackChunkName: "event" */ '@/views/events/Event.vue'),
            },
            {
                path: 'events/:event_id',
                name: 'event',
                component: () => import(/* webpackChunkName: "event" */ '@/views/events/Event.vue'),
            },
            {
                path: 'venues/:id/settings',
                name: 'club-settings',
                component: () => import(/* webpackChunkName: "venuesettings" */ '@/views/venues/VenueSettings.vue'),
            },
            {
                path: 'accounts',
                name: 'accounts',
                component: () => import('@/views/accounts/AccountsOverview.vue'),
            },
            {
                path: 'accounts/:id',
                name: 'account',
                component: () => import('@/views/accounts/Account.vue'),
            },
            {
                path: 'festivals',
                name: 'festivals',
                component: () => import('@/views/venues/VenueOverview.vue'),
            },
            {
                path: 'promoters',
                name: 'promoters',
                component: () => import('@/views/venues/VenueOverview.vue'),
            },
        ],
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach(async (to, from, next) => {
    document.title = 'PartyMate Business'

    if (!to.matched.some((record) => record.meta.authNotRequired)) {
        if (store.getters.token !== '') {
            next()
        } else {
            next({ name: 'login' })
        }
    } else {
        next()
    }
})

export default router
